<template lang="pug">
div
  template(v-if="useFreeTextInput")
    v-text-field.text-sm.round-xl(v-model="freeTextDependentName" placeholder="Enter dependent name" outlined dense height="48" hide-details="auto" @input="updateFreeTextDependent")
  template(v-else)
    v-menu(v-model="show" rounded="lg" allow-overflow :close-on-content-click="false" offset-y content-class="border-menu" max-height="250")
      template(#activator="{ on, attrs }")
        v-sheet.text-md.round-xl.border-menu(v-bind="attrs" v-on="on" flat outlined height="48" min-width="240")
          .d-flex.align-center.fill-height.text-sm.px-3
            .flex-grow-1.text-left(v-if="value") {{ showValue(value) }}
            .flex-grow-1.neutral500--text.text-left(v-else) Enter patient name, NRIC or phone number
            v-btn.mr-1(v-if="clearable && value" icon @click.stop="handleRemoveItem")
              v-icon(size="20") mdi-close
            v-icon(size="20") $yzi-chevron-down
      .text-xs.white
        .search-input
          v-text-field.mb-2.mx-4.text-sm.round-xl(v-model="searchPatient" outlined placeholder="Enter patient name, NRIC or phone number" autofocus dense hide-details clearable)
          v-divider
        .d-flex.align-center.px-4.py-3
          .font-semibold Existing patient with relationships
          y-pagination(v-model="page" :pageSize="pageSize" :count="count" :loading="isFetching")
        v-divider
        div.d-flex.justify-center(v-if="isFetching")
          v-progress-linear(:width="3" rounded color="primary" indeterminate)
        div(v-for="item in patients")
          div.px-4.py-2.clickable.hover-selection(style="width: 100%;" @click="selectItem(item)")
            .text-sm.neutral700--text {{ item.related_person.name }}
            y-chip.my-1.text-xs.info500--text.info200(size="xs") {{ item.relationship.name }}
            v-row.mt-1(no-gutters)
              v-col(cols="4")
                div.d-flex.align-center
                  v-icon(size="15" color="var(-v-neutral500)") $yzi-user-03
                  .text-xs.neutral500--text.ml-1 {{ item.related_person.ic }}
              v-col
                div.d-flex.align-center
                  v-icon(size="15" color="var(-v-neutral500)") $yzi-phone
                  .text-xs.neutral500--text.ml-1 +{{ item.related_person.phone }}
          v-divider
        template(v-if="!patients.length")
          .pa-4
            .py-3 No results match.
              span.underline.px-1.hover-bg(@click="handleRedirectAddPatientRelationship") Please add patient relationship
  div.d-flex.justify-end.mt-1
    y-button(:label="useFreeTextInput ? 'Select from Existing Patient' : 'Enter Dependent Info Manually'" size="sm" button-class="px-0" underline @click="toggleFreeTextInput")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'

export default {
  props: {
    value: null,
    patientId: {
      type: Number,
      required: true
    },
    clearable : {
      type: Boolean,
    }
  },
  data: () => ({
    searchPatient: null,
    show: false,
    isFetching: false,
    isLoading: false,
    page: 1,
    pageSize: 20,
    count: 0,
    patients: [],
    showAddPatientDialog: false,
    useFreeTextInput: false,
    freeTextDependentName: null,
  }),
  watch: {
    show (val) {
      if (val && !this.useFreeTextInput) {
        this.fetchPatientRelationships(this.searchPatient)
      } else {
        if (this.value) {
          this.searchPatient = this.showValue(this.value)
        }
        this.$emit('change')
      }
    },
    page () {
      this.fetchPatientRelationships(this.searchPatient)
    },
    searchPatient () {
      this.searchStart()
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
  },
  mounted () {
    if (this.value && typeof this.value === 'object' && this.value.name) {
      this.freeTextDependentName = this.value.name
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchPatientRelationships (val) {
      this.isFetching = true
      let params = {
        patient: this.patientId,
        expand: 'related_person,relationship',
        search: val || '',
        page: this.page,
        page_size: this.pageSize
      }
      this.$axios.get(`/clinics/${this.company.slug}/patient_relationships`, { params })
        .then(resp => {
          this.patients = resp.data.results
          this.count = resp.data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    searchStart: debounce(function () {
      this.page = 1
      this.fetchPatientRelationships(this.searchPatient)
    }, 750),
    selectItem (item) {
      this.$emit('input', item.related_person)
      this.show = false
    },
    showValue (val) {
      return val && typeof val === 'object' && val.name ? val.name : ''
    },
    handleRedirectAddPatientRelationship () {
      this.$router.push(`/admin/clinic/patient/${this.patientId}?tab=family`)
    },
    handleRemoveItem () {
      this.$emit('input', null)
      this.searchPatient = null
      this.freeTextDependentName = ''
    },
    toggleFreeTextInput () {
      this.useFreeTextInput = !this.useFreeTextInput
      if (this.useFreeTextInput) {
        this.show = false // Close the dropdown
        this.freeTextDependentName = this.value && this.value.name ? this.value.name : ''
        this.$emit('input', { name: this.freeTextDependentName })
      } else {
        this.$emit('input', null)
      }
    },
    updateFreeTextDependent () {
      this.$emit('input', { name: this.freeTextDependentName })
    }
  }
}
</script>

<style scoped>
.border-menu {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
.search-input {
  position: sticky;
  top: 0px;
  background-color: #FFFFFF !important;
  border-color: #FFFFFF !important;
  z-index: 4;
  padding-top: 8px;
}
.hover-selection:hover {
  cursor: pointer;
  background-color: var(--v-infoT08) !important;
}
</style>